import { Flex, Image, Text } from "@chakra-ui/react";
import bridgeImg from "./images/bridge.svg";
import assetsImg from "./images/assets.svg";
import defillamaImg from "./images/defillama.svg";
import logoutImg from "./images/logout.svg";
import TheMenu from "./TheMenu";

const EcosystemDropDown = ({ isCollapse, inDrawer }) => {
  const menuList = [
    {
      title: "Bridge $KTC",
      icon: bridgeImg,
      showOutIcon: true,
      onClick: () => {
        window.open("https://ktx.zkbridge.com/bridge", "_blank");
      },
    },
    {
      title: "Bridge Assets",
      icon: assetsImg,
      onClick: () => {
        window.open("https://app.ktx.finance/bridge", "_blank");
      },
    },
    {
      title: "Defillama",
      icon: defillamaImg,
      showOutIcon: true,
      onClick: () => {
        window.open("https://defillama.com/protocol/ktx.finance", "_blank");
      },
    },
  ];

  const ItemCmp = ({ icon, title, showOutIcon }) => {
    return (
      <Flex
        gap="16px"
        width="252px"
        position="relative"
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        {inDrawer ? null : <Image src={icon} width="24px" height="24px" />}
        <Text fontSize={"sm"} lineHeight={"140%"} flex={1}>
          {title}
        </Text>
        {showOutIcon ? (
          <Image src={logoutImg} width="16px" height="16px" />
        ) : null}
      </Flex>
    );
  };

  return (
    <TheMenu
      menuList={menuList}
      isCollapse={isCollapse}
      ItemCmp={ItemCmp}
      menuLabel="Ecosystem"
      inDrawer={inDrawer}
    />
  );
};

export default EcosystemDropDown;
